"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconDocument = function IconDocument(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconDocument', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    id: "a",
    d: "M7.167.438a.57.57 0 0 1 .412.174l3.5 3.58c.106.108.171.257.171.422l-.007-.094a.61.61 0 0 1 .007.094v7.159c0 .988-.784 1.79-1.75 1.79h-7c-.966 0-1.75-.802-1.75-1.79V2.227c0-.988.784-1.79 1.75-1.79zM6.583 1.63H2.5a.59.59 0 0 0-.583.596v9.546c0 .33.26.596.583.596h7a.59.59 0 0 0 .583-.596V5.21H7.167a.588.588 0 0 1-.576-.5l-.008-.096V1.63zm1.75 7.755a.59.59 0 0 1 .584.597.59.59 0 0 1-.584.597H3.667a.59.59 0 0 1-.584-.597.59.59 0 0 1 .584-.597zm0-2.386a.59.59 0 0 1 .584.597.59.59 0 0 1-.584.596H3.667a.59.59 0 0 1-.584-.596A.59.59 0 0 1 3.667 7zm-3.5-2.386a.59.59 0 0 1 .584.596.59.59 0 0 1-.584.597H3.667a.59.59 0 0 1-.584-.597.59.59 0 0 1 .584-.596zm2.917-2.14v1.543h1.508L7.75 2.473z"
  }));
};

var _default = IconDocument;
exports.default = _default;